import type Theme from '@jetbrains/ring-ui-built/components/global/theme'

import {setUserProperty} from '../../../actions'
import store from '../../../store'
import {UserProperties} from '../../../utils/userProperties'

enum MessageTypes {
  CURRENT_THEME = 'CURRENT_THEME',
}
const kind = 'dark-theme-adapter-sync'

type MessageType = {
  kind: typeof kind
  type: MessageTypes
  payload: Theme
}

const iframePostMessage = (
  type: MessageTypes,
  payload: Theme,
  iframe?: Window | MessageEventSource | null,
) =>
  iframe?.postMessage({
    kind,
    type,
    payload,
  })
const sendChangeThemeRequest = (theme: Theme) => {
  const destinations = document.querySelectorAll<HTMLIFrameElement>(
    'iframe[data-tc-iframe-darktheme-adapter]',
  )
  destinations.forEach(dst => {
    const iframeWindow = dst.contentWindow

    iframePostMessage(MessageTypes.CURRENT_THEME, theme, iframeWindow)
  })
}

const startListening = () => {
  const handler = (event: MessageEvent<MessageType>) => {
    const data = event.data
    if (data?.kind !== kind) {
      return
    }

    switch (data.type) {
      case MessageTypes.CURRENT_THEME:
        store.dispatch(setUserProperty(UserProperties.THEME, data.payload))
        break
      default:
        break
    }
  }

  window.addEventListener('message', handler)

  return () => window.removeEventListener('message', handler)
}

startListening()

export {sendChangeThemeRequest}
